import { ContentPreviewer, Chip, Flex, ReadonlyField, Text } from '@shared/components';

import type { Question } from '../../types';
import { getTagData } from '../../utils';
import { QuestionDetails } from '../question-details';

interface ItemSetQuestionDetailsProps {
  question: Question;
}

export default function ItemSetQuestionDetails(props: Readonly<ItemSetQuestionDetailsProps>) {
  const { question } = props;
  const { questionGroup, tags } = question;

  const { difficulty, calculation, los } = getTagData(tags);

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Text variant='h5'>Paragraph</Text>
        <Chip label={<Text variant='body2Semibold'>Item Set: {questionGroup?.refCode}</Text>} />
      </Flex>
      <ReadonlyField
        content={<ContentPreviewer content={questionGroup?.metadata?.paragraph ?? ''} />}
      />
      <QuestionDetails
        refCode={question.refCode}
        difficulty={difficulty}
        calculation={calculation}
        type={questionGroup?.type}
        // metadata is nullable in questionGroup
        size={questionGroup?.size ?? undefined}
        details={question.details ?? ''}
        choices={question.metadata?.choices ?? []}
        correctAnswer={question.correctAnswer?.value}
        solution={question.solution?.value ?? ''}
        reference={question.metadata?.reference ?? ''}
        los={los}
      />
    </>
  );
}
